export default function TimelinePlayhead({
  currentTime,
  pxPerSec,
  visible,
}: {
  currentTime: number
  pxPerSec: number
  visible: boolean
}) {
  if (!visible) return null

  return (
    <div
      className="pointer-events-none absolute inset-y-0 z-20"
      style={{ left: currentTime * pxPerSec }}
    >
      <div className="absolute -left-[3px] -top-0.5 size-[7px] rounded-full bg-red" />
      <div className="absolute -left-px h-full w-[2px] bg-red" />
    </div>
  )
}
